import { Api } from 'common/api';
import { StriveContent } from 'services/content/types';

export const getResponsibleGaming = (): Promise<StriveContent> => {
  return Api.get<StriveResponse<any>>(
    `${API_HOST}/api/strive-proxy/restapi/v1/content/page/responsible-gaming`,
  ).then((res) => {
    if (!res.ok) {
      throw new Error('Error get about-us');
    }
    return {
      page: res.data.Data.name,
      title: res.data.Data.structure['full area'][0].standart.page_title.value,
      content:
        res.data.Data.structure['full area'][1].section.section_content.value,
    };
  });
};
